import { File } from './general'
import { Category } from './category'
import { Cryptocurrency } from './currency'

interface Fee {
  title: string
  fees: {
    [key: string]: {
      buy: string
      sell: string
    }
  }
}

export interface Fees {
  [key: string]: Fee
}

export interface Feature {
  icon_primary: File
  icon_secondary: File
  name: string
  code: string
  description: string
}

export interface PaymentMethod {
  icon_primary: File
  icon_secondary: File
  name: string
  code: string
  description: string
}

export interface Platform {
  icon_primary: File
  icon_secondary: File
  name: string
  code: string
  description: string
}

export interface Wallet {
  _id: string
  title: string
  review: string
  url: string
  short_description: string
  best_thing: string
  in_short: string
  like: string
  dislike: string
  path_id: string
  promotion: string
  promotion_url: string

  paymentmethods: PaymentMethod[]
  features: Feature[]
  cryptocurrencies: Cryptocurrency[]
  platforms: Platform[]

  features_rating: string
  onboarding_rating: string
  usability_rating: string
  support_rating: string

  lend_amount: number
  release_year: number

  campaign: {
    title: string
    position: number
  }

  fees: Fees
  price: number

  screens: File[]
  logo: File
  icon: File
  sharing_image: File
  photos: File[]

  seo_title: string
  seo_description: string

  category: Category

  createdAt: Date
  updatedAt: Date

  pure_currency: boolean
  networks: string
  integrations: string
  regions: string
  status: 'active' | 'inactive' | undefined
}

export enum WalletType {
  custodial = 'custodial',
  nonCustodial = 'non-custodial',
  physical = 'physical',
}
